const ITEMS = [
  "Ranking Global",
  "Torneos Nocturnos",
  "Panel Personalizado",
  "Bots & Copytrade",
  "Estrategias por Ciclo de Mercado",
  "Medallas por Logros",
  "Comunidad 24/7",
];

export default function Marquee() {
  const Row = () => (
    <div className="flex shrink-0 items-center gap-10 pr-10">
      {ITEMS.map((item, i) => (
        <div key={i} className="flex items-center gap-10">
          <span className="font-display font-bold text-2xl md:text-4xl uppercase tracking-tight whitespace-nowrap">
            {item}
          </span>
          <span className="w-2 h-2 rounded-full bg-black shrink-0" />
        </div>
      ))}
    </div>
  );

  return (
    <div
      className="relative bg-[#BEDD7D] text-black py-5 overflow-hidden border-y-2 border-black"
      data-testid="marquee-features"
    >
      <div className="flex animate-marquee" style={{ animationDuration: "20s" }}>
        <Row />
        <Row />
        <Row />
      </div>
    </div>
  );
}
